const createJpegBlob = (canvas, quality) =>
  new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) resolve(blob);
        else reject(new Error('face_image_encoding_failed'));
      },
      'image/jpeg',
      quality
    );
  });

export async function requestFaceCamera() {
  if (!navigator.mediaDevices?.getUserMedia) {
    throw new Error('camera_not_supported');
  }

  return navigator.mediaDevices.getUserMedia({
    video: {
      facingMode: { ideal: 'user' },
      width: { ideal: 1280 },
      height: { ideal: 720 },
    },
    audio: false,
  });
}

export function stopMediaStream(stream) {
  stream?.getTracks?.().forEach((track) => track.stop());
}

export async function captureFaceImage(video, { quality = 0.9, maxWidth = 1280 } = {}) {
  const sourceWidth = video?.videoWidth || 0;
  const sourceHeight = video?.videoHeight || 0;

  if (!sourceWidth || !sourceHeight) {
    throw new Error('camera_not_ready');
  }

  const scale = Math.min(1, maxWidth / sourceWidth);
  const width = Math.max(1, Math.round(sourceWidth * scale));
  const height = Math.max(1, Math.round(sourceHeight * scale));
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext('2d');
  if (!context) {
    throw new Error('camera_canvas_unavailable');
  }

  context.drawImage(video, 0, 0, width, height);
  const imageBlob = await createJpegBlob(canvas, quality);
  const capturedAt = new Date().toISOString();
  const imageFile = new File([imageBlob], `face-${Date.now()}.jpg`, {
    type: 'image/jpeg',
    lastModified: Date.now(),
  });

  return {
    imageFile,
    mimeType: imageFile.type,
    width,
    height,
    capturedAt,
  };
}

export function prepareFeatureExtractionRequest({ requestId, role, faceImage }) {
  if (!faceImage?.imageFile) {
    throw new Error('face_image_missing');
  }

  const formData = new FormData();
  formData.append('image', faceImage.imageFile, faceImage.imageFile.name);
  if (requestId) formData.append('requestId', requestId);

  return {
    requestId,
    role,
    ...faceImage,
    formData,
  };
}
